var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDiscovery01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#CCC"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.75 3.75h8.222v8.222H3.75z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.222,
  height: 8.222,
  x: 14.028,
  y: 3.75,
  rx: 4.111
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.027 14.028h8.222v8.222h-8.222z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.222,
  height: 8.222,
  x: 3.75,
  y: 14.028,
  rx: 4.111
}))));
export default SvgIconDiscovery01;